import { withTriggerCombobox } from '@udecode/plate-combobox'
import { createTSlatePlugin } from '@udecode/plate-common'
import { toPlatePlugin } from '@udecode/plate-common/react'
import { BaseMentionInputPlugin } from '@udecode/plate-mention'

export const ELEMENT_SLASH_COMMAND = 'slash_command'

const BaseSlashCommandPlugin = createTSlatePlugin({
    key: ELEMENT_SLASH_COMMAND,
    extendEditor: withTriggerCombobox,
    node: { isElement: true, isInline: true, isMarkableVoid: true, isVoid: true },
    options: {
        createComboboxInput: (trigger: string) => ({
            children: [{ text: '' }],
            trigger,
            type: BaseMentionInputPlugin.key,
        }),
        trigger: '/',
        insertSpaceAfterCommand: true,
        triggerPreviousCharPattern: /^$/,
    },
    plugins: [BaseMentionInputPlugin],
})

export const SlashCommandPlugin = toPlatePlugin(BaseSlashCommandPlugin)
